export default {"src":"/_next/static/media/plusBlack.7c586fbb.svg","height":15,"width":16};